/**
 * UI state store (Zustand v5).
 *
 * Manages sidebar collapse, mobile overlay, and other transient UI state.
 *
 * Cross-References:
 *   - Style Schema §2.2: Sidebar collapse behavior
 *   - FR-UI-006: Mobile responsive behavior
 */
import { create } from 'zustand';

interface UiState {
  sidebarCollapsed: boolean;
  /** Whether the mobile sidebar overlay is open (≤768px). */
  mobileSidebarOpen: boolean;
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
  setMobileSidebarOpen: (open: boolean) => void;
}

export const useUiStore = create<UiState>()((set) => ({
  sidebarCollapsed: false,
  mobileSidebarOpen: false,

  toggleSidebar: () =>
    set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),

  setSidebarCollapsed: (sidebarCollapsed) => set({ sidebarCollapsed }),

  setMobileSidebarOpen: (mobileSidebarOpen) => set({ mobileSidebarOpen }),
}));
